var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDesktopLogo = function SvgDesktopLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 994,
    height: 905,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#desktop-logo_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M935.977.302C873.122-.113 835.842 0 819.376.095A84.475 84.475 0 0 0 791.38 4.98c-23.345 8.316-64.081 30.33-89.337 86.2-20.878 46.294-119.181 265.261-205.525 457.665A3785847.906 3785847.906 0 0 1 635.78 859.249l.286.447a155.506 155.506 0 0 0 26.053-41.041c36.325-82.53 322.413-736.206 322.413-736.206S1023.12.893 935.977.302Z",
    fill: "#3BE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m496.517 548.908-139.23 311.186c37.774 42.366 85.309 44.697 85.309 44.697s21.499.415 96.727 0c54.861-.304 96.456-45.511 96.456-45.511l-.732-1.597-138.53-308.775Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.699 859.633a109.165 109.165 0 0 1-2.978-3.48c-2.532-3.065-5-6.385-7.421-9.801a164.117 164.117 0 0 1-15.367-27.632C294.593 736.126 8.521 82.45 8.521 82.45S-30.065.895 57.075.304C119.851-.111 157.114 0 173.613.096a85.237 85.237 0 0 1 28.123 4.901c23.345 8.349 64.033 30.33 89.274 86.201l205.429 457.664-139.15 311.234-.59-.463Z",
    fill: props.fill || '#009EFF'
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "desktop-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h993.035v905H0z"
  })))));
};

export default SvgDesktopLogo;